export interface IConnectedIntegration {
  integrationType: ConnectedIntegrationType
  isConnected: boolean
}

export enum ConnectedIntegrationType {
  None = 'UnDefined',
  NetSuite = 'NetSuite',
  QuickBooks = 'QuickBooks',
  Generic = 'Generic',
  ZohoBooks = 'ZohoBooks',
}

//QuickBooks
export interface IQuickBooksSettings {
  supportCreditMemo: boolean
  arAdvanceSupport: boolean
  disablePayNowFlow: boolean
  disableQuoteAuthorizationFlow: boolean
  syncBackErrorsInFile: boolean
  syncBackCustomerCreditInfoInFile: boolean
}

export enum QuickBooksInputFieldNames {
  SUPPORT_CREDIT_MEMO = 'supportCreditMemo',
  AR_ADVANCE_SUPPORT = 'arAdvanceSupport',
  DISABLE_PAY_NOW = 'disablePayNowFlow',
  DISABLE_QUOTE_AUTHORIZATION = 'disableQuoteAuthorizationFlow',
  SYNC_BACK_ERRORS_IN_FILE = 'syncBackErrorsInFile',
  SYNC_BACK_CUSTOMER_CREDIT_INFO_IN_FILE = 'syncBackCustomerCreditInfoInFile',
}

export interface IQuickBooksFormData {
  [QuickBooksInputFieldNames.SUPPORT_CREDIT_MEMO]: boolean
  [QuickBooksInputFieldNames.AR_ADVANCE_SUPPORT]: boolean
  [QuickBooksInputFieldNames.DISABLE_PAY_NOW]: boolean
  [QuickBooksInputFieldNames.DISABLE_QUOTE_AUTHORIZATION]: boolean
  [QuickBooksInputFieldNames.SYNC_BACK_ERRORS_IN_FILE]: boolean
  [QuickBooksInputFieldNames.SYNC_BACK_CUSTOMER_CREDIT_INFO_IN_FILE]: boolean
}

//NetSuite
export interface INetSuiteSettings {
  consumerKey: string
  consumerSecret: string
  tokenId: string
  tokenSecret: string
  companyUrl: string
  blueTapeSecretKey: string
  blueTapeAccountId: string

  supportCreditMemo: boolean
  arAdvanceSupport: boolean
  disablePayNowFlow: boolean
  disableQuoteAuthorizationFlow: boolean
}

export enum NetSuiteInputFieldNames {
  CONSUMER_KEY = 'consumerKey',
  CONSUMER_SECRET = 'consumerSecret',
  TOKEN_ID = 'tokenId',
  TOKEN_SECRET = 'tokenSecret',
  COMPANY_URL = 'companyUrl',
  BLUE_TAPE_SECRET_KEY = 'blueTapeSecretKey',
  BLUE_TAPE_ACCOUNT_ID = 'blueTapeAccountId',
  SUPPORT_CREDIT_MEMO = 'supportCreditMemo',
  AR_ADVANCE_SUPPORT = 'arAdvanceSupport',
  DISABLE_PAY_NOW_FLOW = 'disablePayNowFlow',
  DISABLE_QUOTE_AUTHORIZATION_FLOW = 'disableQuoteAuthorizationFlow',
}

export interface INetSuiteFormData {
  [NetSuiteInputFieldNames.CONSUMER_KEY]: string
  [NetSuiteInputFieldNames.CONSUMER_SECRET]: string
  [NetSuiteInputFieldNames.TOKEN_ID]: string
  [NetSuiteInputFieldNames.TOKEN_SECRET]: string
  [NetSuiteInputFieldNames.COMPANY_URL]: string
  [NetSuiteInputFieldNames.BLUE_TAPE_SECRET_KEY]: string
  [NetSuiteInputFieldNames.BLUE_TAPE_ACCOUNT_ID]: string
  [NetSuiteInputFieldNames.SUPPORT_CREDIT_MEMO]: boolean
  [NetSuiteInputFieldNames.AR_ADVANCE_SUPPORT]: boolean
  [NetSuiteInputFieldNames.DISABLE_PAY_NOW_FLOW]: boolean
  [NetSuiteInputFieldNames.DISABLE_QUOTE_AUTHORIZATION_FLOW]: boolean
}

//Generic
export interface IGenericSettings {
  blueTapeApiUrl: string
  blueTapeAccountId: string
  blueTapeSecretKey: string
  clientSecretKey: string
  quoteResponseUrl: string
  invoiceResponseUrl: string
  invoiceStatusUpdateUrl: string
}

export enum GenericInputFieldNames {
  BLUE_TAPE_API_URL = 'blueTapeApiUrl',
  BLUE_TAPE_ACCOUNT_ID = 'blueTapeAccountId',
  BLUE_TAPE_SECRET_KEY = 'blueTapeSecretKey',
  CLIENT_SECRET_KEY = 'clientSecretKey',
  QUOTE_RESPONSE_URL = 'quoteResponseUrl',
  INVOICE_RESPONSE_URL = 'invoiceResponseUrl',
  INVOICE_STATUS_UPDATE_URL = 'invoiceStatusUpdateUrl',
}

export interface IGenericFormData {
  [GenericInputFieldNames.BLUE_TAPE_API_URL]: string
  [GenericInputFieldNames.BLUE_TAPE_ACCOUNT_ID]: string
  [GenericInputFieldNames.BLUE_TAPE_SECRET_KEY]: string
  [GenericInputFieldNames.CLIENT_SECRET_KEY]: string
  [GenericInputFieldNames.QUOTE_RESPONSE_URL]: string
  [GenericInputFieldNames.INVOICE_RESPONSE_URL]: string
  [GenericInputFieldNames.INVOICE_STATUS_UPDATE_URL]: string
}
